import { createContext } from "react";

export type ToastVariant = "success" | "info" | "error";

export type ToastOptions = {
    title: string;
    description?: string;
    duration?: number;
    action?: { label: string; onClick: () => void };
};

export type ToastContextValue = {
    show: (
        options: ToastOptions & {
            variant: ToastVariant;
        },
    ) => void;
    success: (title: string, description?: string) => void;
    info: (title: string, description?: string) => void;
    error: (title: string, description?: string) => void;
    dismiss: (id: string) => void;
};

export const ToastContext = createContext<ToastContextValue | null>(null);
